import React from 'react'
import styles from './Footer.module.css'


const Footer = () => {
  return (
    <div>
      <footer className={styles.footer}>
  
        <p>© 2025 Rafaella Chijner. Todos os direitos reservados.</p>
      </footer>
    </div>
  )
}

export default Footer
